export default __webpack_public_path__ + "static/media/blog-post-layout-05-img-03.a3ab5fb2.jpg";